import { setPersonalPhoto, setSignUpStep } from '../../../../store/signUp/slice';
import { CameraIcon, PaperclipIcon } from '../../../../assets/icons/common';
import MotionWrapper from '../../../../containers/MotionWrapper';
import { Dispatch, SetStateAction, useState } from 'react';
import { useWebcam } from '../../../../hooks/useWebcam';
import { useDispatch } from '../../../../store/store';
import DropBox from '../../../../containers/DropBox';
import Button from '../../../../components/Button';
import styles from './style.module.scss';
import Webcam from 'react-webcam';

const sample = require('../../../../assets/images/kyc_personal.png');
type Mode = 'Camera' | 'Upload';

interface Props {
    file: File | null;
    setFile: Dispatch<SetStateAction<File | null>>;
};

function UploadProfilePhoto(props: Props) {
    const dispatch = useDispatch();
    const { file, setFile } = props;
    const [mode, setMode] = useState<Mode>('Camera');

    const {
        imgSrc,
        webcamRef,
        setImgSrc,
        captureImage,
    } = useWebcam();

    const takePhoto = () => {
        if (imgSrc) {
            setImgSrc(null)
        } else {
            captureImage();
        }
    };

    const changeMode = () => {
        setImgSrc(null);
        setFile(null);
        setMode(prev => prev === 'Camera' ? 'Upload' : 'Camera');
    };

    const next = () => {
        if (mode === 'Upload' && file) {
            const objectURL = URL.createObjectURL(file);
            dispatch(setPersonalPhoto(objectURL));
        } else {
            dispatch(setPersonalPhoto(imgSrc));
        }

        dispatch(setSignUpStep('uploadPersonalID'));
    };

    return (
        <MotionWrapper className={styles.wrapper}>
            <div className={styles.box}>
                {mode === 'Camera' && <>
                    <span className={styles.box_title}>
                        Please position your face within the frame
                    </span>
                    <div className={styles.sample}>
                        <img src={sample} alt="sample" />
                    </div>
                    <div className={styles.camera}>
                        {!imgSrc ? <Webcam
                            audio={false}
                            ref={webcamRef}
                            disablePictureInPicture
                            screenshotFormat="image/png"
                        /> : <img src={imgSrc} />}
                    </div>
                    <div className={styles.actions}>
                        <Button
                            onClick={takePhoto}
                            icon={<CameraIcon />}
                            type='Outline-Primary'
                            className={styles.actions_btn}
                            text={imgSrc ? 'Retake photo' : 'Take photo'}
                        />
                    </div>
                </>}
                {mode === 'Upload' && <>
                    <span className={styles.box_title}>
                        Please upload your face photo
                    </span>
                    <DropBox
                        file={file}
                        uploading={false}
                        setFile={setFile}
                        fileTypes={{ 'image': ['.PNG', '.JPEG', '.JPG'], }}
                        description='PNG, JPEG or JPG , Maximum upload file size: 12MB'
                    />
                </>}
            </div>
            <div className={styles.change_option}>
                <span className={styles.change_option_text}>
                    {mode === 'Camera' ? ' Also you can upload the relevent documents' : 'Also you can take a live photo of your face'}
                </span>
                <div
                    className={styles.change_option_link}
                    onClick={changeMode}
                >
                    {mode === 'Camera' ? <PaperclipIcon /> : <CameraIcon />}
                    <span>
                        {mode === 'Camera' ? ' Upload document' : 'Take photo'}
                    </span>
                </div>
            </div>
            <div className={styles.actions}>
                <Button
                    size='sm'
                    text='Back'
                    type='Outline-Dark'
                    className={styles.actions_btn}
                    onClick={() => dispatch(setSignUpStep('personalInfo'))}
                />
                <Button
                    size='sm'
                    type='Primary'
                    text='Continue'
                    onClick={next}
                    disabled={!imgSrc && !file}
                    className={styles.actions_btn}
                />
            </div>
        </MotionWrapper>
    );
};

export default UploadProfilePhoto;
